import { FC, useState } from 'react'
import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import PdfViewer from 'components/PdfViewer'
import { HEADER_HEIGHT } from '@client-hub/shared/constants/styles'
import { Button, Loader } from '@icanbwell/ui-toolkit'
import Toolbar from 'components/Header/Toolbar'
import { useHubTokenValidation } from 'hooks/auth'
import Link from '@client-hub/shared/react/components/Link'
import ROUTES from '@client-hub/shared/constants/routes'

type Props = {
  title: string
  doc: {
    link: string | undefined
    loading: boolean
  }
}

const LegalDocBase: FC<Props> = ({ doc: { link, loading }, title }) => {
  const { t } = useTranslation()
  const [isValid, { isLoading }] = useHubTokenValidation()
  const [pdfLoaded, setPdfLoaded] = useState(false)

  const handlePdfLoadSuccess = () => setPdfLoaded(true)

  return (
    <Box>
      <Toolbar sx={{ display: 'flex', alignItems: 'flex-end' }}>
        {isLoading ? null : (
          <Link to={isValid ? ROUTES.BASE : ROUTES.LOGIN.BASE}>
            <Button size="small" sx={{ backgroundColor: 'common.brand', minWidth: 'auto' }}>
              {isValid ? t('routes.legalDocs.home') : t('routes.legalDocs.signIn')}
            </Button>
          </Link>
        )}
      </Toolbar>
      <Box mt={`calc(${HEADER_HEIGHT} + 1em)`} display="flex" flexDirection="column" alignItems="center">
        <Typography
          variant="h4"
          sx={{ borderBottomColor: 'grey.400', borderBottomStyle: 'solid', borderBottomWidth: '1px', pb: 2 }}
        >
          <strong>{title}</strong>
        </Typography>
      </Box>
      {link && (
        <Box mt={2} display={pdfLoaded ? 'flex' : 'none'} justifyContent="center">
          <PdfViewer scale={1.5} file={link} onLoadSuccess={handlePdfLoadSuccess} scrollToOffset={-50} />
        </Box>
      )}
      {(loading || !pdfLoaded) && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100vw',
            mt: '12em',
          }}
        >
          <Loader  />
        </Box>
      )}
    </Box>
  )
}

export default LegalDocBase
